<template>
  <Card>
    <template #title>
      <Toolbar>
        <template #left>
          <div class="p-card-title">
            Wilmar Electronic Permit to Work System
          </div>
        </template>
      </Toolbar>
    </template>
    <template #content>
      <p class="m-0">Welcome {{ this.username }}</p>
    </template>
  </Card>
</template>

<script>
export default {
  name: "Welcome",
  data() {
    return {
      username: this.$store.getters.getUsername,
    };
  },
};
</script>
